import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function DVDivaTyte() {
  return <section className="bg-black py-[50px] lg:py-[80px]" data-id="element-999">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1000">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1001">
          <span className="text-[#FF1493] uppercase text-[13px] font-bold tracking-[2px] mb-4 font-[Poppins,_sans-serif]" data-id="element-1002">
            ADD ON FOR OPTIMAL RESULTS
          </span>

          <h2 className="text-[24px] lg:text-[36px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-1003">
            DIVATYTE
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1004"></div>

          <p className="text-[#B0B0B0] text-[17px] leading-[1.7] font-body" data-id="element-1005">
            For women looking to maximize their results, combining diVaTyte with
            diVa laser therapy can provide comprehensive rejuvenation, targeting
            both internal and external vaginal tissue. This combination enhances
            overall appearance and function, helping you feel your best.
          </p>
        </AnimateOnScroll>
      </div>
    </section>;
}